import { useAttrs as g, computed as u, inject as f, isRef as h, ref as d, watch as m, getCurrentInstance as y, onMounted as A } from "vue";
import { D as E, T as b } from "./TimeFormat-CdFMIbra.js";
import { r as R } from "./dom-qGGG2YCX.js";
import { g as S } from "./getPageElevations-BuZyM94T.js";
import { useMutationObserver as C, useResizeObserver as $, refDebounced as F, useMediaQuery as P } from "@vueuse/core";
import O from "@onereach/styles/screens.json";
import Z from "@onereach/styles/tailwind.config.json";
const Q = () => {
  const e = g();
  return {
    readonly: u(() => e.readonly),
    disabled: u(() => e.disabled),
    "force-state": u(() => e["force-state"])
  };
}, Y = Symbol(), L = Symbol(), U = Symbol(), V = Symbol(), _ = Symbol(), W = (e) => u(() => e.value ?? f(Y, E.Short)), k = (e, t) => u(() => typeof e.value != "function" ? new Intl.DateTimeFormat(t.value, {
  dateStyle: e.value,
  timeZone: "UTC"
}).formatToParts(Date.UTC(1, 0, 1, 1, 1)).reduce((n, r) => {
  switch (r.type) {
    case "year":
      return n + r.value.replace(/^\d{2}$/, "YY").replace(/^\d{4}$/, "YYYY");
    case "month":
      switch (e.value) {
        case "short":
          return n + r.value.replace(/^\d{1}$/, "M").replace(/^\d{2}$/, "MM");
        case "medium":
          return n + "MMM";
        case "long":
          return n + "MMMM";
        default:
          throw new Error("[useDateMask]: `format` has an invalid value.");
      }
    case "day":
      return n + r.value.replace(/^\d{1}$/, "D").replace(/^\d{2}$/, "DD");
    default:
      return n + r.value;
  }
}, "") : e.value(void 0, t.value)), G = (e, t) => {
  const a = h(e) ? e : d(e), n = h(t) ? t : d(), r = f(V, 0), l = f(_, 1 / 0);
  function i(s) {
    const o = S(s);
    let c = Math.max(r, ...o) + 1;
    c = Math.min(c, l), s.style.zIndex = String(c);
  }
  m([a, n], ([s]) => {
    s && i(s);
  }, { immediate: !0 });
}, J = () => {
  const e = g(), t = y();
  return u(() => e.id ?? (t == null ? void 0 : t.uid.toString()));
}, K = (e) => u(() => e.value ?? f(L, navigator.language)), ee = (e, t = {}) => {
  const { hide: a = !0, threshold: n = 0 } = t, r = h(e) ? e : d(e), l = d([]), i = d([]);
  function s() {
    const o = r.value;
    if (o) {
      const c = [...o.children].reduce(({ innerItems: p, outerItems: M }, I) => {
        const v = I, { x: T, width: D } = v.getBoundingClientRect(), { x: w, width: x } = o.getBoundingClientRect();
        return T + D > w + x + n ? (a && v.style.setProperty("visibility", "hidden"), {
          innerItems: p,
          outerItems: [...M, v]
        }) : (a && v.style.removeProperty("visibility"), {
          innerItems: [...p, v],
          outerItems: M
        });
      }, {
        innerItems: [],
        outerItems: []
      });
      l.value = c.innerItems, i.value = c.outerItems;
    } else
      l.value = [], i.value = [];
  }
  return m(r, s, {
    immediate: !0
  }), C(r, s, {
    childList: !0
  }), $(r, () => R(s)), {
    innerItems: l,
    outerItems: i
  };
}, te = (e, t, a = {}) => {
  const n = d(e.value ? "open" : "closed");
  m(e, (o) => {
    n.value = o ? "open" : "closed";
  });
  const r = F(n, a.debounce ?? 0);
  m(r, (o) => {
    switch (t("update:state", o), o) {
      case "open":
        t("open");
        break;
      case "closed":
        t("close");
        break;
    }
  });
  function l() {
    n.value = "open";
  }
  function i() {
    n.value = "closed";
  }
  function s() {
    n.value = n.value === "open" ? "closed" : "open";
  }
  return {
    state: r,
    open: l,
    close: i,
    toggle: s
  };
};
function ne(e, t, a = {}) {
  const { defaultValue: n } = a;
  return n ? u({
    get: () => e.value ?? n.value,
    set: (r) => {
      t("update:modelValue", r);
    }
  }) : u({
    get: () => e.value,
    set: (r) => {
      t("update:modelValue", r);
    }
  });
}
function re(e) {
  const t = y(), a = d();
  e ? m(e, (s) => {
    a.value = s;
  }) : A(() => {
    if (t) {
      const s = t.vnode, o = s.el || s.elm;
      o instanceof Element && (a.value = o);
    }
  });
  const n = u(() => i(a.value) || l.value), r = u(() => !n.value), l = P(`(min-width: ${O.md})`);
  function i(s) {
    var c;
    if (!s)
      return !1;
    const o = (c = s.getAttribute("force-screen")) == null ? void 0 : c.split(/\s+/);
    return o != null && o.some((p) => ["md", "lg", "xl"].includes(p)) ? !0 : i(s.parentElement ?? void 0);
  }
  return {
    isDesktop: n,
    isMobile: r
  };
}
const se = () => Z.theme, ue = (e) => u(() => e.value ?? f(U, b.Auto)), oe = (e, t) => u(() => typeof e.value != "function" ? new Intl.DateTimeFormat(t.value, {
  timeStyle: "short",
  hourCycle: e.value !== b.Auto ? e.value : void 0,
  timeZone: "UTC"
}).formatToParts(Date.UTC(1, 0, 1, 1, 1)).reduce((n, r) => {
  switch (r.type) {
    case "hour":
      return n + r.value.replace(/^\d{1}$/, "H").replace(/^\d{2}$/, "HH");
    case "minute":
      return n + r.value.replace(/^\d{1}$/, "M").replace(/^\d{2}$/, "MM");
    case "dayPeriod":
      return n + "A";
    default:
      return n + r.value;
  }
}, "") : e.value(void 0, t.value));
function ae(e = !1) {
  const t = d(e);
  function a() {
    t.value = !0;
  }
  function n() {
    t.value = !1;
  }
  function r() {
    t.value = !t.value;
  }
  return {
    isActiveToggle: t,
    show: a,
    hide: n,
    toggle: r
  };
}
const ie = () => {
  const e = g();
  return {
    required: u(() => e.required),
    minlength: u(() => e.minlength),
    maxlength: u(() => e.maxlength),
    pattern: u(() => e.pattern),
    min: u(() => e.min),
    max: u(() => e.max),
    step: u(() => e.step)
  };
};
export {
  Y as D,
  L,
  V as M,
  U as T,
  Q as a,
  W as b,
  k as c,
  G as d,
  J as e,
  K as f,
  ee as g,
  te as h,
  ne as i,
  re as j,
  se as k,
  ue as l,
  oe as m,
  ie as n,
  _ as o,
  ae as u
};
